var App = App || {};

App.Login = (function ($) {
    "use strict";

    var _isOpen,
        $toggle,
        $panel,
        $body,
        firstFocusable,
        lastFocusable;

    function init() {
        $toggle = $('#login');
        $panel = $('.login__panel');
        $body = $('body');

        $('a[href="#login"]')
            .on('click.login', openLogin);

        $('a[href="#login"]')
            .on('keydown.login', function (e) {
                if (e.keyCode === 13) {
                    openLogin;
                }
            });

        if (!isEmpty($('.login-promo-personalized > div'))) {
            $('.login-promo-default').hide();
        }

        $toggle
            .on('click.login', toggleLogin);

        $panel
            .on('keydown', function (e) {
                if (e.key === 'Tab' || e.keyCode === 9) {
                    if (document.activeElement === lastFocusable) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                        e.preventDefault();
                        closeLogin();
                    }
                }
            });

        App.Base.$body
            .on('keydown.login', function (e) {
                if (_isOpen && e.keyCode === 27) {
                    closeLogin();
                }
            });

        $(document).on('click', function (event) {
            if (_isOpen) {
                if (!$(event.target).closest('.login__wrapper').length && !$(event.target).closest('.login__toggle').length) {
                    closeLogin();
                }
            }

        });
    }

    function toggleLogin() {
        _isOpen ? closeLogin() : openLogin();
    }

    function openLogin() {
        if (App.HamburgerNav.isOpenMobile()) {
            App.HamburgerNav.closeMenu();
        }

        if (App.PrimaryNav.isOpenDesktop()) {
            App.PrimaryNav.closeNav();
        }

        $panel
            .one('animationend', function () {
                $panel
                    .focus();

                updateFocusableElements();
                _isOpen = true;
            })
            .css("z-index", "1041")
            .addClass('animate__animated animate__slideInRight')
            .show()
            .attr('aria-hidden', 'false')
            .find('.login__panel').attr('aria-hidden', 'false').attr('tabindex', '0')
        $toggle
            .attr('aria-expanded', 'true')
            .addClass('login__toggle--open');

        $('a[href="#login"]').blur();
        $('#username').focus();
    }

    function closeLogin() {
        $panel
            .css("z-index", "8")
            .one('animationend', function () {
                $panel
                    .removeClass('animate__animated animate__slideOutRight')
                    .hide();
                _isOpen = false;
            })
            .removeClass("animate__slideInRight")
            .addClass("animate__slideOutRight")
            .attr('aria-hidden', 'true')
            .find('.login__panel').attr('aria-hidden', 'true').attr('tabindex', '-1');;

        $toggle
            .attr('aria-expanded', 'false')
            .removeClass('login__toggle--open')
            .focus();

        $toggle.focus();
    }

    function updateFocusableElements() {
        firstFocusable = $panel.find('a, button, :input, [tabindex]').first(':visible')[0];
        lastFocusable = $panel.find('a, button, :input, [tabindex]').last(':visible')[0];
    }

    function isEmpty(el) {
        return !$.trim(el.html())
    }


    return {
        init: init,
        closeLogin: closeLogin,
        isOpen: function () { return _isOpen; }
    };
})(jQuery);

$(function () {
    App.Login.init();
});